













import { backend } from "@/.config";
import { addScriptTag } from "@/api/dom";
import { expandPath, formatFileSize } from "@/api/helpers";
import { MediaItem } from "@/api/models";
import { Component, Prop, Vue } from "vue-property-decorator";
import { notEmptyString } from "../../api/validators";

class HTMLModelElement extends HTMLElement {
  loaded: boolean;
}

@Component({
  components: {},
  filters: {},
})
export default class ModelFrame extends Vue {
  @Prop({ default: () => new MediaItem() }) mediaItem: MediaItem;

  hasModelViewer = false;

  loaded = false;

  loading = true;

  created() {
    this.loadRemote();
  }

  mounted() {
    setTimeout(this.handleLoad, 500);
  }

  get matchedSource() {
    return notEmptyString(this.mediaItem.source, 2)? this.mediaItem.source : 'local';
  }

  get filename() {
    return this.mediaItem.filename;
  }

  get hasMedia() {
    return this.mediaItem instanceof Object && this.mediaItem.size  > 0;
  }

  get fileSize() {
    return this.hasMedia ? formatFileSize(this.mediaItem.size) : '';
  }

  get extension() {
    return this.hasMedia ? '.' + this.mediaItem.filename.split('.').pop() : '';
  }

  get refId() {
    return ['mv', this.mediaItem._id].join('-');
  }

  get figureClasses() {
    const cls = ['model-container'];
    if (this.loaded) {
      cls.push('loaded');
    }
    if (this.loading) {
      cls.push('loading');
    }
    return cls;
  }

  get altRef() {
    return this.mediaItem.title;
  }

  get filePath() {
    switch (this.mediaItem.source) {
      case "cloudinary":
        return this.filename;
      default:
        return expandPath(this.filename)
    }
  }

  buildFullPath() {
    const { mediaPath } = backend;
    const basePath = mediaPath.startsWith('/') ? [window.location.origin, mediaPath].join('') : mediaPath;
    return [basePath, this.filename].join('');
  }

  loadRemote() {
    const el = addScriptTag('https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js', 'google-model-viewer-script', true, 'module');
    if (el instanceof HTMLScriptElement) {
      setTimeout(() => {
        this.hasModelViewer = true;
        this.loading = false;
      }, 250);
    }
  }

  handleLoad() {
    // Hack to trick typescript into recognising loaded as a valid property
    const refEl: HTMLModelElement = document.getElementById(this.refId) as HTMLModelElement;
    if (refEl instanceof Object) {
      if (refEl.loaded) {
        this.loaded = refEl.loaded;
      } else {
        refEl.addEventListener('load', () => {
          this.loaded = true;
        });
      }
    }
  }

  get fullPath() {
    switch (this.mediaItem.source) {
      case "cloudinary":
        return this.filename;
      default:
        return this.buildFullPath();
    }
  }
}
